'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'circle-user';
var width = 512;
var height = 512;
var aliases = [62142,"user-circle"];
var unicode = 'f2bd';
var svgPathData = ['M48 256c0 60.2 25.6 114.5 66.5 152.5l29.5-88.5 224 0 29.5 88.5c40.9-38 66.5-92.2 66.5-152.5 0-114.9-93.1-208-208-208S48 141.1 48 256zm296-56a88 88 0 1 1 -176 0 88 88 0 1 1 176 0z', 'M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 60.2 25.6 114.5 66.5 152.5l29.5-88.5 224 0 29.5 88.5c40.9-38 66.5-92.2 66.5-152.5zM333.4 368l-154.8 0-23.3 70c29.8 16.6 64.2 26 100.7 26s70.9-9.4 100.7-26l-23.3-70zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm216-56a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm40 88a88 88 0 1 1 0-176 88 88 0 1 1 0 176z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleUser = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;